/**
 * @generated SignedSource<<7052991347d47bc90cc91bb7b32bbf89>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RenderChildRowsComp_rules$data = {
  readonly " $fragmentSpreads": FragmentRefs<"Rows_rules">;
  readonly " $fragmentType": "RenderChildRowsComp_rules";
};
export type RenderChildRowsComp_rules$key = {
  readonly " $data"?: RenderChildRowsComp_rules$data;
  readonly " $fragmentSpreads": FragmentRefs<"RenderChildRowsComp_rules">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "RenderChildRowsComp_rules",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "Rows_rules"
    }
  ],
  "type": "JiraFormattingRuleConnection"
};

(node as any).hash = "c7d2d776221c63e40579cb004a5363d9";

export default node;
